<div
  (click)="goToApplication(application)"
  class="grid-item-container relative flex justify-center items-center"
>
  <span
    class="application-icon px-4 py-2 rounded-md w-16 h-16 text-center items-center content-center mt-1"
    [class]="application?.color ?? 'bg-surface-tertiary text-color'"
  >
    <soft-icon
      *ngIf="application?.icon !== ''; else defaultIcon"
      [name]="application?.icon"
      class="text-3xl"
    ></soft-icon>
  </span>
  <div class="soft-container soft-container-center set-width">
    <span class="application-title self-baseline">{{
      application?.name | translate
    }}</span>
  </div>

  @if (application?.type === 'link') {
    <div class="absolute top-2 right-2.5">
      <soft-icon
        name="fa-regular fa-arrow-up-right-from-square"
        class="text-sm opacity-50"
      ></soft-icon>
    </div>
  }
</div>

<ng-template #defaultIcon>
  <i class="fa-regular fa-ban fa-3x"></i>
</ng-template>
